import React, { createContext, useState } from 'react';

export const MyContext = createContext<any>({});